<template>
  <div>
    <shop-head currentPageName="qpgtt"></shop-head>
    <div class="content_wrapper">
      <div class="container">
        <el-radio-group
          v-model="type"
          style="margin-bottom: 30px; width: 100%; white-space: nowrap"
          @change="typeChange"
        >
          <el-radio-button :label="$t('资讯')" name="1"></el-radio-button>
          <el-radio-button :label="$t('视频')" name="2"></el-radio-button>
        </el-radio-group>
        <div class="content">
          <div :class="search.type == '1' ? 'newsList' : 'newsList newsList2'">
            <div class="premium" v-if="search.type == '1'">
              <h1 style="font-weight: 500; color: #1684fc; line-height: 40px">
                {{ newsList[0].name }}
              </h1>
              <p>{{ newsList[0].details }}</p>
              <br />
              <el-carousel height="300px">
                <el-carousel-item
                  v-for="item in newsList[0].images.split(',')"
                  :key="item"
                >
                  <img :src="item" alt="" />
                </el-carousel-item>
              </el-carousel>
            </div>
            <div
              style="
                width: 100%;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
              "
            >
              <div
                v-for="item in newsList.slice(1)"
                :key="item.id"
                :style="
                  search.type == '1'
                    ? 'width: 100%;margin-bottom:20px'
                    : 'width: 30%'
                "
              >
                <div @click="goDetail(item)" v-if="search.type == '1'">
                  <el-col :span="5" :offset="0" style="margin-right: 15px">
                    <img
                      style="width: 100%; height: 100px"
                      :src="item.images"
                      alt=""
                  /></el-col>
                  <el-col :span="18" :offset="0">
                    <b>{{ item.name }}</b>
                    <p>{{ item.details }}</p>
                    <p>
                      {{ item.createTime | formatDate }} &nbsp;&nbsp;<i
                        class="el-icon-thumb"
                      >
                        {{ item.praiseCount }}</i
                      >&nbsp;&nbsp;&nbsp; <i class="el-icon-chat-square"></i>
                      {{ item.commentCount }}
                    </p>
                  </el-col>
                </div>
                <div
                  @click="goDetail(item)"
                  v-if="search.type == '2'"
                  class="movies"
                >
                  <img
                    style="width: 100%; height: 200px; object-fit: fill"
                    :src="item.images"
                    alt=""
                  />
                  <h3 style="font-weight: 600">{{ item.name }}</h3>
                  <p>{{ item.details }}</p>
                  <p>
                    <span style="font-weight: 600">{{ item.author }}</span>
                    {{ item.createTime | formatDate }}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <i class="el-icon-thumb">
                      {{ item.praiseCount }}
                    </i>
                    &nbsp;&nbsp;&nbsp;
                    <i class="el-icon-chat-square"></i>
                    {{ item.commentCount }}
                  </p>
                </div>
              </div>
            </div>
            <br />
            <br />
            <el-pagination
              background
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleChangeSize"
              @current-change="handleSearch"
            />
          </div>
          <div class="hots" v-if="search.type == '1'">
            <h2 style="border-bottom: 3px solid #184d7f">
              {{ type == $t("资讯") ? $t("热门资讯") : $t("热门视频") }}
            </h2>
            <el-row
              :gutter="20"
              v-for="item in newsList"
              :key="item.id"
              style="
                margin-bottom: 20px;
                padding-bottom: 10px;
                border-bottom: 0px solid #c7c3c3;
                cursor: pointer;
              "
            >
              <div @click="goDetail(item)">
                <b style="padding: 0px 10px; display: block;margin-bottom: 10px;">{{ item.name }}</b>
                <el-col :span="10" :offset="0">
                  <img
                    style="width: 100%; height: 100px"
                    :src="item.images"
                    alt=""
                /></el-col>
                <el-col :span="14" :offset="0">
                  <p>{{ item.details }}</p>
                </el-col>
              </div>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import shopHead from "../../components/shop/head";
import commonFooter from "../../components/common/footer";
import breadcrumb from "../../components/common/breadcrumb";
import { getnewsList } from "../../apis/qpgtt";
export default {
  components: {
    shopHead,
    commonFooter,
    breadcrumb,
  },
  filters: {
    formatDate(time) {
      return time ? new Date(time).toLocaleString() : "--";
    },
  },
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      type: this.$i18n.t("资讯"),
      search: {
        name: "",
        type: "1",
        status: "",
        // "creatorId": "",
        sortAs: "BROWSE_TIMES desc",
        currentPage: 1,
        pageSize: 10,
      },
      newsList: [{ images: "" }],
    };
  },
  watch: {
    showDetail(val) {},
  },
  created() {
    this.getList();
  },
  methods: {
    goDetail(data) {
      this.$router.push({
        path: "/newsDetail",
        query: data,
      });
    },
    typeChange(e) {
      if (e == "资讯" || e == "视频") {
        this.search.type = { 资讯: "1", 视频: "2" }[e];
      } else {
        this.search.type = { News: "1", "Video News": "2" }[e];
      }
      this.getList();
    },
    async getList() {
      const { total, list } = (await getnewsList(this.search)).data;
      this.newsList = list;
      this.total = total;
    },
    handleChangeSize(value) {
      this.pageSize = value;
      this.search.pageSize = value;
      this.handleSearch();
    },
    // 查询数据
    handleSearch(currentPage = 1) {
      this.currentPage = currentPage;
      this.search.currentPage = currentPage;
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.search,
          currentPage,
        },
      });
      this.getList();
    },
    /** 跳转详情 */
    gotoDetail(id) {
      this.$router.push({
        path: "/shopDetail",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #fff;
  ::v-deep .el-radio-button__inner {
    font-size: 16px;
    padding: 15px 260px;
  }

  .content {
    display: flex;

    .newsList {
      width: 70%;
      padding: 10px;
      // border-right: 1px solid #c7c3c3;
      display: flex;
      flex-direction: column;
      align-items: center;

      .premium {
        margin-bottom: 20px;

        .el-carousel__item img {
          width: 100%;
          height: 100%;
          line-height: 300px;
          margin: 0;
        }
      }
      .movies {
        width: 100%;
        display: inline-block;
        // border: 1px solid red;
        margin-bottom: 40px;
      }
    }
    .newsList2 {
      width: 100%;
    }
    .hots {
      width: 30%;
      padding-left: 5px;
      overflow: hidden;
    }
  }
}
</style>